export const FETCH_SEO_SETTINGS_REQUEST = "FETCH_SEO_SETTINGS_REQUEST";
